// extracted by mini-css-extract-plugin
export default {"card":"LY-z","carouselContainer":"MY-z","carouselContent":"NY-z"};